import type {
    ExtensionDefinition,
    FrontendPlugin,
} from "@backstage/frontend-plugin-api";
import {
    ApiBlueprint,
    createApiFactory,
    createFrontendPlugin,
    discoveryApiRef,
    identityApiRef,
} from "@backstage/frontend-plugin-api";
import { TemporalBackendClient } from "@internal/backstage-plugin-temporal-common";
import { temporalApiRef } from "@internal/backstage-plugin-temporal-react";

/**
 * Registers the {@link temporalApiRef} API factory, providing a
 * {@link TemporalBackendClient} backed by the Backstage discovery and
 * identity APIs.
 */
const temporalApi: ExtensionDefinition = ApiBlueprint.make({
    name: "temporal",
    params: defineParams =>
        defineParams(
            createApiFactory({
                api: temporalApiRef,
                deps: {
                    discoveryApi: discoveryApiRef,
                    identityApi: identityApiRef,
                },
                factory: ({ discoveryApi, identityApi }) =>
                    new TemporalBackendClient({ discoveryApi, identityApi }),
            })
        ),
});

/**
 * The Temporal frontend plugin.
 *
 * Auto-discovered via `app.packages: all`. Registers the
 * {@link temporalApiRef} API so consumers (e.g. `gcp-project-approvals`) can
 * resolve it with `useApi`. Consumers import the ref from
 * `@internal/backstage-plugin-temporal-react`, not from this package.
 *
 * @public
 */
const temporalPlugin: FrontendPlugin = createFrontendPlugin({
    pluginId: "temporal",
    extensions: [temporalApi],
});

export default temporalPlugin;
